<template>
    <div class="menu-button-container">
        <button class="draggable-item-menu-btn draggable-item-menu-btn-blue draggable-item-menu-btn-split-merge" @click="openModal">
            Unir tarjeta
        </button>
        <transition name="slide-fade">
            <MergeOrderReferenceButtonActionModal 
                v-if="showModal"
                :orderReference="orderReference"
                :endOfAction="endOfAction"
                :closeModal="closeModal"
            />
        </transition>
    </div>
</template>

<script>
import MergeOrderReferenceButtonActionModal from './MergeOrderReferenceButtonActionModal.vue';

export default {
    name: "MergeOrderReferenceButton",
    components: {
        MergeOrderReferenceButtonActionModal,
    },
    props: {
        orderReference: {
            type: Object,
            required: true
        },
        endOfAction: {
            type: Function,
            required: true
        },
    },
    data() {
        return {
            showModal: false,
        }
    },
    methods: {
        openModal() {
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
        },
    }
};
</script>